@if (!data) {
    <div class="d-flex">
		<ion-skeleton-text class="tumb-card flex-shrink-0 my-0" />

		<div class="content w-100 position-relative p-2 p-lg-3 d-flex flex-column justify-content-between" >
			<div>
				<ion-skeleton-text class="card-tag my-0" />
				<ion-skeleton-text class="mt-2 mb-0" />
			</div>

			<ion-skeleton-text style="height:24px" class="mt-3 mb-0" />
		</div>
	</div>
} @else {
	<a type="link" routerDirection="forward" routerLink="/article/{{ data.urlKey }}" class="d-flex text-decoration-none">
		<div class="tumb-card position-relative flex-shrink-0">
			@if (data.contentOption) {
                <div class="position-absolute w-100 h-100 d-flex justify-content-center align-items-center rounded-lg">
					<iframe [src]="url" title="{{ data.postTitle }}" width="100%" height="100%" class="border-0 rounded-lg"></iframe>
				</div>
			} @else {
				<picture>
					<source media="(max-width:991px)" srcset="{{ data.squareThumbnail }}">
				  
					<img [src]="isSquare? data.squareThumbnail : data.thumbnails[0]" alt="{{ data.postTitle }}" loading="lazy" class="position-absolute w-100 h-100 rounded" (error)="onImgError($event)">
				</picture>	
			}
		</div>
	
		<div class="content w-100 position-relative p-2 p-lg-3 d-flex flex-column justify-content-between">
			<div class="card-tag" (click)="stopProp($event)">
				@for (tag of data.tags; track tag?.guid) {
					<a type="link" routerLink="/tag/{{ tag?.urlKey }}" routerDirection="root" class="rounded-tag text-decoration-none">{{ tag?.termName }}</a>
				}	
			</div>
	
			<div class="title fsemibold mt-2 text-truncate text-wrap text-white">{{ data.postTitle }}</div>
	
			<div class="author mt-2 pt-1">
			    <a class="author text-decoration-none" type="link" routerDirection="root" routerLink="/author/{{ data.author?.url }}" (click)="stopProp($event)">{{ data.authorName }}</a> • {{ data.publishDuration }}
			</div>
		</div>
	</a>
}
